const DAY = 86400000;

export function plural(n: number, word: string): string {
  return `${n} ${word}${n === 1 ? '' : 's'}`;
}

export function formatDate(ts: number): string {
  return new Date(ts).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

export function relativeDays(ts: number, now = Date.now()): string {
  const days = Math.round((ts - now) / DAY);
  if (days === 0) return 'today';
  if (days === 1) return 'tomorrow';
  if (days === -1) return 'yesterday';
  return days > 0 ? `in ${days} days` : `${-days} days ago`;
}

export type DueStatus = { label: string; tone: 'danger' | 'warning' | 'accent' | 'neutral' };

export function dueStatus(nextReview: number, revisions: number, now = Date.now()): DueStatus {
  if (revisions === 0 && nextReview <= now) return { label: 'New', tone: 'accent' };
  const overdue = Math.floor((now - nextReview) / DAY);
  if (overdue >= 1) return { label: `Overdue ${overdue}d`, tone: 'danger' };
  const endOfToday = new Date(now).setHours(23, 59, 59, 999);
  if (nextReview <= endOfToday) return { label: 'Due today', tone: 'warning' };
  return { label: relativeDays(nextReview, now), tone: 'neutral' };
}

// Local-midnight timestamp for a yyyy-mm-dd input value.
export function localDayStart(value: string): number {
  return new Date(`${value}T00:00:00`).getTime();
}

export function toInputDate(ts: number): string {
  const d = new Date(ts);
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${mm}-${dd}`;
}
